const CURRICULUMTODOLIST_QUERIES = {
    CURRICULUMTODOLIST_LIST: 'curriculumtodolist-list',
  }
  
  export {CURRICULUMTODOLIST_QUERIES}